<script>
    import {mdiPlus,mdiPencil,mdiDelete,mdiPlaylistEdit} from '@mdi/js';
    import {Button,Modal,Card,Input,Checkbox} from 'svelte-chota';
    import {api} from '../lib/api'
    import {onMount} from 'svelte';
    import {router} from 'tinro';
    import projects from './../stores/project.js';

</script>

<table class="striped">
<tr>
    <th>Project</th>
    <th>Last change</th>
    <th></th>
</tr>
{#each $projects as project}
    <tr>
        <td>{project.name}</td>
        <td>
            {project.modified ? project.modified.replace('T',' ').replace(/\.\d+Z/,'') : 'Today'}
        </td>
        <td align="right">
           <Button on:click={()=>router.goto(`/ide/${project.dir}`)}>Open IDE</Button> 
           <Button on:click={()=>router.goto(`/files/${project.dir}`)}>Browse files</Button> 
        </td>
    </tr>
{:else}
    <tr><td colspan=3><p class="text-center text-grey">No projects</p></td></tr>
{/each}
</table>